import fallbackTeamBadge from '../assets/graphics/fallback-team-badge.svg';
import fallbackPlayerAndFormations from '../assets/graphics/fallback-player-and-formations.svg';
import fallbackPlayer from '../assets/graphics/fallback-player.svg';

/**
 * Gets the ODIR image URL with the correct
 * width & tenant params
 *
 * @param {string} imgUrl image base URL
 * @param {number} [width] image width
 * @returns {string} odir image URL with width and tenant
 */
export const getImageUrl = (imgUrl, width = '') => {
    if (imgUrl?.includes('blob:')) {
        return imgUrl;
    }

    const tenant = window?.PLAYBOOK_CONFIG?.tenant
        ? window.PLAYBOOK_CONFIG.tenant
        : window?.PLAYBOOK_TENANT;

    return `${imgUrl}?width=${width}&tenant=${tenant}`;
};

/**
 * On error image helper/handler
 * Sets a placeholder image if the image fails to load
 *
 * @param {object} event the browser event
 * @returns {void} sets the image src to a placeholder on error
 */
export const onErrorImage = (event) => {
    event.target.src = fallbackTeamBadge;
};

/**
 * On error image helper/handler
 * Sets a placeholder image if the image fails to load
 *
 * @param {object} event the browser event
 * @returns {void} sets the image src to a placeholder on error
 */
export const onErrorFormationOrPlayerImage = (event) => {
    event.target.src = fallbackPlayerAndFormations;
};

/**
 * On error image helper/handler
 * Sets a placeholder image if the image fails to load
 *
 * @param {object} event the browser event
 * @returns {void} sets the image src to a placeholder on error
 */
export const onErrorPlayerImage = (event) => {
    event.target.src = fallbackPlayer;
};
